const bannerData = {
  name: "Shravari Patil",
  bannerTextOne: "Making Data",
  bannerTextTwo: "Easier To Use!",
  typeText: "I",
  profile_image_path: "shravari-profile.png",
};

export { bannerData };
